<h2 mat-dialog-title>Change Contact Status</h2>
<div mat-dialog-content>
  <div>
    <form [formGroup]="changeStatusForm">
        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
        style="margin-bottom: 20px;align-items: baseline;">
        <mat-form-field style="width: 100%" appearance="outline">
          <mat-select formControlName="status">
            <mat-option value="New">New</mat-option>
            <mat-option value="In Progress">In Progress</mat-option>
            <mat-option value="Completed">Completed</mat-option>
          </mat-select>
          <mat-error *ngIf="
              changeStatusForm.controls['status'].touched &&
              changeStatusForm.controls['status'].hasError(
                'required'
              )
            ">
            This field is required.
          </mat-error>
        </mat-form-field>
      </fxLayout>

      <div class="buttonarea">
        <button type="button" color="primary" mat-raised-button (click)="changeStatus()">
          <span> Change </span>
        </button>
       <button type="button" class="buttonclose" mat-button mat-dialog-close>Close</button>
        
      </div>
    </form>
  </div>
</div>



